import type { ReactNode } from 'react';
import { VibesitesImage } from '@vibesites/ui-primitives';
import { HERO_FONT_CLASS, HeroFont } from './HeroFont';

export const INNER_HERO_SUBTITLE_CLASS =
  `mb-2 max-w-3xl ${HERO_FONT_CLASS} text-sm font-medium leading-snug tracking-wide text-white/90 sm:text-base md:text-lg [&_p]:m-0`;
export const INNER_HERO_TITLE_CLASS =
  `${HERO_FONT_CLASS} text-3xl font-normal uppercase tracking-wider sm:text-4xl md:text-5xl [&_p]:m-0`;

/** Background image (or solid fallback) plus the dark overlay. */
export function InnerHeroBackground({ image, alt }: { image: string | null; alt: string }) {
  return (
    <>
      {image ? (
        <VibesitesImage
          url={image}
          alt={alt}
          priority
          sizes="100vw"
          className="h-full w-full object-cover"
        />
      ) : (
        <div className="h-full w-full bg-[var(--vibe-color-text)]" />
      )}
      <div className="absolute inset-0 bg-black/40" />
    </>
  );
}

/** Banner frame shared by PageHero and the dedicated inner page heroes. */
export function InnerHeroShell({
  background,
  children,
}: {
  background: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="relative h-[30vh] min-h-[200px] max-h-[350px] overflow-hidden">
      <HeroFont />
      {background}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center text-white">
        {children}
      </div>
    </section>
  );
}
